import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;

const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id']

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}

// Recalcula la fila en la que estamos trabajando
function calculateRow(row) {
    // Tomamos la cantidad (si está vacía, asumimos 0)
    var quantity = parseFloat(row.find('.quantity-input').val()) || 0;

    // Tomamos el precio unitario que ya está bloqueado en el input
    var unitPrice = parseFloat(row.find('.unit-price-input').val()) || 0;

    // Matemáticas
    var subtotal = quantity * unitPrice;
    var totalWithIva = subtotal * 1.16; // Multiplicamos por 16% de IVA

    // Imprimimos el resultado con 2 decimales en el input de total
    row.find('.total-price-input').val(totalWithIva.toFixed(2));

    calculateGrandTotal();
}

// SUMAR TODAS LAS FILAS
function calculateGrandTotal() {
    var grandTotal = 0;

    // Iteramos sobre las filas que NO están ocultas (ignoramos las eliminadas)
    $('#quote-items-container .quote-item-row:visible').each(function() {
        var rowTotal = parseFloat($(this).find('.total-price-input').val()) || 0;
        grandTotal += rowTotal;
    });
    // Imprimimos el total en el formulario principal
    $('.grand-total-input').val(grandTotal.toFixed(2));
}

function setupQuotesForm() {
    const form = document.getElementById("quotes-form");
    if (form) {
        // console.log('Quotes turbolinks loaded.')
        $('#add-quote-item').on('click', function(e) {
            e.preventDefault();

            var uniqueId = new Date().getTime();
            var templateHtml = $('#quote-item-template').html();
            var newRowHtml = templateHtml.replace(/NEW_RECORD/g, uniqueId);

            var $newRow = $(newRowHtml);

            $newRow.find('.select2-container').remove();
            $newRow.find('select')
                .removeClass('select2-hidden-accessible')
                .removeAttr('data-select2-id aria-hidden tabindex id');
            $newRow.find('option').removeAttr('data-select2-id');

            $('#quote-items-container').append($newRow);

            $newRow.find('select').select2({
                width: '100%',
                theme: 'classic' // Quítalo si notas que el estilo no cuadra con el original
            });
        });

        // Cuando cambia el selector de batería (actualizado con list-price)
        $('#quote-items-container').on('change', 'select.bci-select-class', function() {
            var row = $(this).closest('.quote-item-row');
            var selectedOption = $(this).find('option:selected');

            // Leemos tu atributo personalizado
            var price = parseFloat(selectedOption.attr('list-price')) || 0;

            row.find('.unit-price-input').val(price.toFixed(2));

            if (!row.find('.quantity-input').val()) {
                row.find('.quantity-input').val(1);
            }

            calculateRow(row);
        });

        // Cuando cambia la cantidad calcula la fila
        $('#quote-items-container').on('input', '.quantity-input', function() {
            var row = $(this).closest('.quote-item-row');
            calculateRow(row);
        });

        // ELIMINAR PARTIDA
        $('#quote-items-container').on('click', '.remove-quote-item', function(e) {
            e.preventDefault();

            // Buscamos la fila entera
            var row = $(this).closest('.quote-item-row');

            // Le decimos a Rails que lo marque para destruir
            row.find('.destroy-flag').val('1');

            // Ocultamos la fila visualmente
            row.hide();

            calculateGrandTotal();
        });
        calculateGrandTotal();
    }
}

function destroyQuotesForm() {
    const form = document.getElementById("quotes-form");
    if (form) {
        // console.log("Cleanup quotes-form...")
        $('#add-quote-item').off('click');
        $('#quote-items-container').off('click');
        $('#quote-items-container').off('change');
        $('#quote-items-container').off('input');
        // clearSelect2(...select2Ids)
    }
}
document.addEventListener("turbolinks:load", setupQuotesForm);
// document.addEventListener('turbolinks:before-cache', destroyQuotesForm);
window.addEventListener('beforeunload', (event) => {
    destroyQuotesForm();
});


